






























import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";
import { serverBase } from "../../apollo";

@Component({
  components: {},
})
export default class Stats extends Vue {
  info = null as null | any;

  created() {
    this.getInfo();
  }

  async getInfo() {
    const res = await Axios.get(serverBase + "/remaining-time", {
      headers: {
        "X-PASS": localStorage.getItem("password"),
      },
    });
    this.info = res.data;
  }
}
